const state = () => ({
  shownewuserpopup:false,
  newmemberadded:false,
});
const getters = {
  shownewuserpopup(state){
    return state.shownewuserpopup
  },
  newmemberadded(state){
    return state.newmemberadded
  },
};
const  mutations =  {
  SET_NEWUSERPOPUP(state,data){
    state.shownewuserpopup = data
  },
  SET_NEWMEMBERADDED(state,data){
    state.newmemberadded = data
  },
};
const actions =  {
  setNewUserPopup({commit},data)  {
    commit("SET_NEWUSERPOPUP",data)
  },
  setNewMemberAdded({commit},data)  {
    commit("SET_NEWMEMBERADDED",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

